/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Storage_InfoInputs */



/**
* | output |
* | --- |
* | "Getting storage info..." |
*
* @param {Iconik_Import_Status_Storage_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_storage_info = /** @type {((inputs?: Iconik_Import_Status_Storage_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Storage_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recuperation des informations de stockage...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherinformationen werden abgerufen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ottenimento informazioni di archiviazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получение информации о хранилище...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Obteniendo información de almacenamiento...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在获取存储信息...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ストレージ情報を取得しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भंडारण संबंधी जानकारी प्राप्त की जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Obtendo informações de armazenamento...")
	return /** @type {LocalizedString} */ ("Getting storage info...")
});